export default {
      id: "file-type-presentation-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#file-type-presentation",
      toString: function () {
        return this.url;
      }
    }